import { Component, effect, output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AppConfig } from '../../shared/app.config';
import { isUserName, isValidPassword, matchPasswords } from '../../utils/validations/field-rules';
import { toSignal } from '@angular/core/rxjs-interop';

export interface CredentialsSubmitPayload {
  userIdentifier: string;
  password: string;
  confirmPassword: string;
  securityQuestion1?: string;
  securityAnswer1?: string;
  securityQuestion2?: string;
  securityAnswer2?: string;
  securityQuestion3?: string;
  securityAnswer3?: string;
}

@Component({
    selector: 'app-credentials',
    templateUrl: './credentials.component.html',
    styleUrls: ['./credentials.component.scss'],
    standalone: false
})
export class CredentialsComponent {
  constructor(private readonly fb: UntypedFormBuilder, private readonly config: AppConfig) {
    this.securityQuestions = this.config.securityQuestions;
    this.credentialsForm = this.fb.group({
      userIdentifier: ['', [isUserName, Validators.required]],
      password: ['', [isValidPassword, Validators.required]],
      confirmPassword: ['', [matchPasswords, Validators.required]]
    });

    const passwordControl = this.credentialsForm.get('password');
    if (!passwordControl) {
      return;
    }

    const passwordValue = toSignal(passwordControl.valueChanges, {
      initialValue: passwordControl.value
    });

    effect(() => {
      passwordValue();
      this.credentialsForm.get('confirmPassword')?.updateValueAndValidity({ emitEvent: false });
    });
  }

  credentialsForm: UntypedFormGroup;
  readonly credentialsSubmit = output<CredentialsSubmitPayload>();
  securityQuestions: string[];

  filterQuestions(): void {
    this.securityQuestions = this.config.securityQuestions.filter(y => y !== this.credentialsForm.controls.securityQuestion1.value &&
      y !== this.credentialsForm.controls.securityQuestion2.value && y !== this.credentialsForm.controls.securityQuestion3.value);
  }
}
